export type MediaUnitId = string | number;

export type SelectionState = {
  selectedIds: ReadonlySet<MediaUnitId>;
};

export type SelectionAction =
  | { type: 'TOGGLE_ONE'; id: MediaUnitId }
  | { type: 'ADD_MANY'; ids: readonly MediaUnitId[] }
  | { type: 'REMOVE_MANY'; ids: readonly MediaUnitId[] }
  | { type: 'CLEAR' }
  | { type: 'REPLACE'; ids: readonly MediaUnitId[] };

export function selectionReducer(state: SelectionState, action: SelectionAction): SelectionState {
  switch (action.type) {
    case 'TOGGLE_ONE': {
      const next = new Set(state.selectedIds);
      if (next.has(action.id)) {
        next.delete(action.id);
      } else {
        next.add(action.id);
      }
      return { selectedIds: next };
    }
    case 'ADD_MANY': {
      const next = new Set(state.selectedIds);
      for (const id of action.ids) {
        next.add(id);
      }
      return { selectedIds: next };
    }
    case 'REMOVE_MANY': {
      const next = new Set(state.selectedIds);
      for (const id of action.ids) {
        next.delete(id);
      }
      return { selectedIds: next };
    }
    case 'CLEAR': {
      return { selectedIds: new Set() };
    }
    case 'REPLACE': {
      return { selectedIds: new Set(action.ids) };
    }
  }
}

export const INITIAL_SELECTION_STATE: SelectionState = {
  selectedIds: new Set(),
};
